import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../services/IpAssistantService';
import { ipAssistantKeys } from './queryKeys';
export function useIpAssistantSettings() {
    return useQuery({
        queryKey: ipAssistantKeys.settings(),
        queryFn: getSettings,
        staleTime: 5 * 60 * 1000,
        retry: 3
    });
}
